module.exports = __webpack_public_path__ + "static/img/floor3-wfsskg.2c221f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-wfsskg.png
// module id = UYfo
// module chunks = 1